/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container, Row } from 'reactstrap';

// import images
import CarouselPage from './CarouselPage';

// import components
import IButtonComponent from '../../components/Common/iComponents/iButton/IButton';
import { useDispatch, useSelector } from 'react-redux';

//import sagas
import { setNewPasswordRequest } from '../../store/actions';

import { useHistory } from 'react-router-dom';
import getUrlParams from '../../components/Common/getUrlParams/getUrlParams';
import * as urlHelper from '../../helpers/url_helper';

// El token del correo se valida en el servidor (ValidateResetToken / ResetPasswordWithToken):
// el navegador ya no recibe el token ni la clave del usuario.
const MIN_PASSWORD = 8;
const llamarApi = async (query: string, variables: any) => {
  const r = await fetch(urlHelper.API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  }).then((x) => x.json());
  if (r?.errors?.length) throw new Error(r.errors[0].message);
  return r?.data || {};
};
const validarToken = async (correo: string, key: string) => {
  const d = await llamarApi(
    `query ($data: ResetPasswordInput) { ValidateResetToken(data: $data) }`,
    { data: { USUARIO_CORREO: correo, key } },
  );
  return !!d.ValidateResetToken;
};
const cambiarClave = async (correo: string, key: string, password: string) => {
  const d = await llamarApi(
    `mutation ($data: ResetPasswordInput) { ResetPasswordWithToken(data: $data) { success message } }`,
    { data: { USUARIO_CORREO: correo, key, password } },
  );
  return d.ResetPasswordWithToken || { success: false, message: 'There has been an error.' };
};

const RecoverPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { url, brand } = getUrlParams({ name: 'nwkID' });

  const search = window.location.search;

  const params = new URLSearchParams(search);
  const email = params.get('email');
  const key = params.get('key');

  const { success, message, loading } = useSelector((state: any) => state.Users);

  const [state, setState] = useState({
    email: '',
    validEmail: true,
    validSecondPassword: false,
    password: '',
    secondPassword: '',
  });
  const [tokenOk, setTokenOk] = useState<boolean | null>(null);
  const [cambio, setCambio] = useState<{ loading: boolean; done: boolean; message: string }>({
    loading: false,
    done: false,
    message: '',
  });

  useEffect(() => {
    if (email && key) {
      validarToken(email, key)
        .then(setTokenOk)
        .catch(() => setTokenOk(false));
    }
  }, [email, key]);

  useEffect(() => {
    setState({
      ...state,
      validSecondPassword: state.password === state.secondPassword,
    });
  }, [state.secondPassword, state.password]);

  function validarCorreoElectronico(correo: any) {
    const expresion = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return expresion.test(correo);
  }

  const claveCorta = state.password !== '' && state.password.length < MIN_PASSWORD;

  const passwordTemplate = () => {
    return (
      <>
        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            value={state.password}
            type="password"
            className="form-control"
            onChange={(e) => {
              setState({ ...state, password: e.target.value });
            }}
          />
          <label className="form-label pt-2">Repeat new password</label>
          <input
            value={state.secondPassword}
            type="password"
            className="form-control"
            onChange={(e) => {
              setState({ ...state, secondPassword: e.target.value });
            }}
          />
        </div>
        {claveCorta ? (
          <label className="form-label" style={{ color: 'red' }}>
            The password must have at least {MIN_PASSWORD} characters.
          </label>
        ) : null}
        {!state.validSecondPassword ? (
          <label className="form-label" style={{ color: 'red' }}>
            The passwords do not match.
          </label>
        ) : null}
        {cambio.message && !cambio.done ? (
          <label className="form-label" style={{ color: 'red' }}>
            {cambio.message}
          </label>
        ) : null}
        <div className="mb-3 mt-4">
          <IButtonComponent
            actionOnClick={() => {
              changePasswordHanlder();
            }}
            className={'w-100 button waves-light'}
            label={'Change Password'}
          />
        </div>
        {cambio.loading ? LoadingIndicator() : null}
      </>
    );
  };

  const setRequestTemplate = () => {
    return (
      <>
        <div className="mb-3">
          <label className="form-label">Email*</label>
          <input
            style={{ border: state.validEmail ? '' : 'solid 1px red' }}
            value={state.email}
            onChange={(e) => {
              setState({ ...state, validEmail: true, email: e.target.value });
            }}
            type="text"
            className="form-control"
            id="email"
            placeholder="Enter email"
          />
        </div>
        {!state.validEmail ? (
          <label className="form-label" style={{ color: 'red' }}>
            Invalid email address
          </label>
        ) : null}
        <div className="mb-3 mt-4">
          <IButtonComponent
            actionOnClick={() => {
              newRequestHanlder();
            }}
            className={'w-100 button waves-light'}
            label={success ? 'Resend Email' : 'Send request'}
          />
        </div>
        {loading ? LoadingIndicator() : null}
      </>
    );
  };

  const LoadingIndicator = () => {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  };

  const newRequestHanlder = () => {
    const validEmail = validarCorreoElectronico(state.email);
    if (validEmail) {
      dispatch(
        setNewPasswordRequest({
          email: state.email,
          url: window.location.href,
        }),
      );
    } else {
      setState({ ...state, validEmail });
    }
  };

  const changePasswordHanlder = async () => {
    if (!email || !key || !state.validSecondPassword || state.password.length < MIN_PASSWORD) return;
    setCambio({ loading: true, done: false, message: '' });
    try {
      const r = await cambiarClave(email, key, state.password);
      setCambio({ loading: false, done: !!r.success, message: r.message || '' });
    } catch (e: any) {
      setCambio({ loading: false, done: false, message: e?.message || 'There has been an error.' });
    }
  };

  const aviso = () => {
    if (!(email && key)) return message ? message : 'Enter your Email and instructions will be sent to you! ';
    if (tokenOk === null) return 'Checking your link...';
    if (!tokenOk) return 'Expired code';
    return cambio.done ? cambio.message : 'Successful request';
  };

  return (
    <React.Fragment>
      <PageTitle>
        <title>Reset Password | {brand.name}</title>
      </PageTitle>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <Link to={url} className="d-block auth-logo">
                        <img src={brand.logo} alt="" height="60" />{' '}
                      </Link>
                    </div>
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h5 className="mb-0">Reset Password</h5>
                        <p className="text-muted mt-2">
                          Reset Password with {brand.name}.
                        </p>
                      </div>
                      <div
                        className="alert alert-success text-center mb-4 mt-4 pt-2"
                        role="alert"
                      >
                        {aviso()}
                      </div>

                      {cambio.done ? null : email && key ? (
                        tokenOk === null ? (
                          LoadingIndicator()
                        ) : tokenOk ? (
                          passwordTemplate()
                        ) : (
                          <div className="mb-3 mt-4">
                            <IButtonComponent
                              actionOnClick={() => {
                                history.push('/auth-recoverpw' + url);
                              }}
                              className={'w-100 button waves-light'}
                              label={'Resend request'}
                            />
                          </div>
                        )
                      ) : (
                        setRequestTemplate()
                      )}

                      <div className="mt-5 text-center">
                        <p className="text-muted mb-0">
                          Remember It ?{' '}
                          <Link
                            to={'/login' + url}
                            className="text-primary fw-semibold"
                          >
                            {' '}
                            Sign In{' '}
                          </Link>{' '}
                        </p>
                      </div>
                    </div>
                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} {brand.name}.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RecoverPassword;
